import React from 'react';
import { STATS, text } from './constant';
import styles from './index.css';
import { easing } from './util';
import PropTypes from 'prop-types';
import { isIOS } from '@src/public/utils';

class Tloader extends React.Component {
    state = {
        loaderState: STATS.init,
    };

    pullHeight = 0;

    handle = e => {
        if (this.state.loaderState !== STATS.init && this.state.loaderState !== STATS.reset) {
            e.preventDefault();
        }
    };

    componentDidMount() {
        document.addEventListener('touchmove', this.handle, { passive: false });
    }

    canRefresh(e) {
        const arr = [STATS.refreshing, STATS.refreshed];

        e.stopPropagation();
        const { onRefresh } = this.props;
        const { loaderState } = this.state;
        const bol = onRefresh && arr.indexOf(loaderState) < 0;
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        // if (!(bol && scrollTop <= 0)) {
        //     const endState = {
        //         loaderState: STATS.reset,
        //         pullHeight: 0,
        //     };

        //     this.setState(endState);
        // }

        return bol && scrollTop <= 0;
    }

    touchStart = e => {
        try {
            this.panel1.style.transition = 'transform 0s';
            if (!this.canRefresh(e)) return;
            const clientY = e.touches[0].clientY;

            //  安全区域，在此区域滑动不会造成页下拉刷新
            if (
                this.props.safeArea &&
                Math.abs(clientY - this.props.safeArea.top) < 20 &&
                Math.abs(this.props.safeArea.bottom - clientY) < 20
            ) {
                return;
            }
            if (this.state.loaderState === STATS.enough) {
                return;
            }

            if (e.touches.length === 1) {
                const { panel } = this;

                this.initialTouch = {
                    clientY: e.touches[0].clientY,
                    clientX: e.touches[0].clientX,
                    scrollTop: panel.scrollTop,
                };
            }
        } catch (e) {
            console.log(e);
        }
    };

    touchMove = e => {
        if (!this.canRefresh(e)) return;

        const { panel } = this;
        const { distanceToRefresh } = this.props;
        const { scrollTop } = panel;
        const { distanceY, distanceX } = this.calculateDistance(e.touches[0]);

        if (distanceY > 0 && Math.abs(distanceX) < Math.abs(distanceY) && scrollTop <= 0) {
            let pullDistance = distanceY - this.initialTouch.scrollTop;

            if (pullDistance < 0) {
                // 修复 webview 滚动过程中 touchstart 时计算panel.scrollTop不准
                pullDistance = 0;
                this.initialTouch.scrollTop = distanceY;
            }
            const newPullHeight = easing(pullDistance) * 0.5;

            // const newPullHeight = Math.min(pullHeight, 150);

            this.panel1.style.transform = `translate3d(0,${newPullHeight}px,0)`;
            this.pullHeight = newPullHeight;
            this.setState({
                loaderState: newPullHeight > distanceToRefresh ? STATS.enough : STATS.pulling,
            });
        }
    };

    reset = () => {
        try {
            const animation = this.panel1.animate(
                [{ transform: `translate3d(0,${this.pullHeight}px,0)` }, { transform: 'translate3d(0,0,0)' }],
                {
                    duration: 150,
                    fill: 'forwards',
                },
            );

            animation.onfinish = () => {
                this.setState({
                    loaderState: STATS.reset,
                });
                this.pullHeight = 0;
                this.panel1.style.transform = `translate3d(0,${0}px,0)`;
                animation.cancel();
            };
        } catch (e) {
            this.setState({
                loaderState: STATS.reset,
            });

            this.panel1.style.transition = 'transform 0.15s';
            setTimeout(() => {
                this.panel1.style.transition = 'transform 0s';
            }, 150);

            this.panel1.style.transform = 'translate3d(0,0,0)';
            this.pullHeight = 0;
        }
    };
    touchEnd = e => {
        if (!this.canRefresh(e, true)) return;

        const currentTime = Date.now();

        this.timer = setTimeout(() => {
            // 4s之后自动清空
            this.reset();
        }, 4000);

        // eslint-disable-next-line init-declarations
        let timer1, timer2;

        if (this.state.loaderState === STATS.enough) {
            // refreshing
            this.setState({
                loaderState: STATS.refreshing,
            });

            // trigger refresh action
            this.props.onRefresh(
                () => {
                    const time = Date.now() - currentTime;
                    // resolve

                    clearTimeout(this.timer);
                    timer1 = setTimeout(() => {
                        this.setState({
                            loaderState: STATS.refreshed,
                        });
                        setTimeout(() => {
                            this.reset();
                        }, 200);
                    }, Math.max(time, 1000));
                },
                () => {
                    const time = Date.now() - currentTime;

                    clearTimeout(this.timer);
                    timer2 = setTimeout(() => {
                        // reject
                        this.setState({
                            loaderState: 'error',
                        });
                        setTimeout(() => {
                            this.reset();
                        }, 200);
                    }, Math.max(time, 1000));
                },
                () => {
                    this.reset();
                    clearTimeout(this.timer);
                    clearTimeout(timer1);
                    clearTimeout(timer2);
                },
            );
        } else {
            this.reset();
        }
    };

    animationEnd = () => {
        const newState = {};

        if (this.state.loaderState === STATS.refreshed) newState.loaderState = STATS.init;

        this.setState(newState);
    };

    calculateDistance(touch) {
        return {
            distanceY: touch.clientY - this.initialTouch?.clientY,
            distanceX: touch.clientX - this.initialTouch?.clientX,
        };
    }

    render() {
        const { children, style: propStyle = {} } = this.props;
        const { loaderState } = this.state;

        return (
            <>
                <div
                    ref={el => {
                        this.panel = el;
                    }}
                    onClick={e => {
                        e.stopPropagation();
                    }}
                    style={isIOS() ? {} : { ...propStyle }}
                    className={`${styles['tloader']} ${styles[`state-${loaderState}`]}`}
                    onTouchStart={this.touchStart}
                    onTouchMove={this.touchMove}
                    onTouchEnd={this.touchEnd}
                    onAnimationEnd={this.animationEnd}>
                    <div
                        className={styles['tloader-body']}
                        ref={el => {
                            this.panel1 = el;
                        }}>
                        <div ref={el => (this.tipRef = el)} className={styles.tip}>
                            {text[loaderState] && <span className={styles.loading} />}
                            <div>{text[loaderState]}</div>
                        </div>
                        {children}
                    </div>
                </div>
                {isIOS() && <div className={styles.placeHolder} style={{ ...propStyle }} />}
            </>
        );
    }
}

Tloader.propTypes = {
    onRefresh: PropTypes.func.isRequired,
    children: PropTypes.any,
    distanceToRefresh: PropTypes.number,
    // 传递的样式
    style: PropTypes.object,
    /**
     * 安全区域，安全区域内不会触发下拉刷新事件
     */
    safeArea: PropTypes.object,
};

Tloader.defaultProps = {
    distanceToRefresh: 70,
};

export default Tloader;
